var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { loadingGifGlobalSearch, maxMobile, maxTablet, } from '../../../../Utils/utilsStyle';
import { Popover } from 'antd';
import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { selectSearchData, selectUniqueTagItemList } from '../../../../Selector/ChatBotV2Selector';
import { actions } from '../../../../Slice/ChatbotV2Slice';
import { actions as flurryActions } from '../../../../Slice/HelperSlice';
import NoPersonsFound from '../../../common/components/NoPersonsFound';
import { TAG_LIMIT } from '../../../../Utils/Constants';
import classNames from 'classnames';
import { valueToObject, getCurrentTime, getLangCookie } from '../../../../Utils/UtilityFunctions';
import PopoverTabs from './PopoverTabs';
import BRMResultTagging from './BRMResultTagging';
import CompanyResultTagging from './CompanyResultTagging';
import PeopleResultTagging from './PeopleResultTagging';
import DocResultTagging from './DocResultTagging';
import { GilroyContext } from '../../../GilroyContext';
var ContentWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n&.loaderWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n&.ContentV3 {\n  .no-person-found-wrapper {\n    height: calc(100% - 60px);\n  }\n}\nheight: 100%;\npadding: 12px 16px 2px;\n@media all and (max-width: ", ") {\npadding: 8px 2px;\n}\n.gif-loader {\n  width: 125px;\n  height: 125px;\n  @media all and (max-width: ", ") {\n    width: 110px;\n    height: 110px;\n  }\n}\n.no-person-found-wrapper {\n height: calc(100% - 60px);\n  h3 {\n    font-size: 20px;\n  }\n}\n"], ["\n&.loaderWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n&.ContentV3 {\n  .no-person-found-wrapper {\n    height: calc(100% - 60px);\n  }\n}\nheight: 100%;\npadding: 12px 16px 2px;\n@media all and (max-width: ", ") {\npadding: 8px 2px;\n}\n.gif-loader {\n  width: 125px;\n  height: 125px;\n  @media all and (max-width: ", ") {\n    width: 110px;\n    height: 110px;\n  }\n}\n.no-person-found-wrapper {\n height: calc(100% - 60px);\n  h3 {\n    font-size: 20px;\n  }\n}\n"])), maxTablet, maxMobile);
var PopoverContent = function PopoverContent(_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var activeTab = _a.activeTab, onCrossClick = _a.onCrossClick, popoverOpen = _a.popoverOpen;
    var gilroyStates = useContext(GilroyContext).gilroyStates;
    var host = window.location.href;
    var dispatch = useDispatch();
    var _j = useState(activeTab), active = _j[0], setActive = _j[1];
    var searchData = useSelector(selectSearchData);
    // const taggedList = useSelector(selectTaggedList);
    var uniqueTagList = useSelector(selectUniqueTagItemList);
    var peopleSection = searchData.peopleSection, buyerSection = searchData.buyerSection, companiesSection = searchData.companiesSection, searchLoading = searchData.searchLoading, extendedSearchLoaded = searchData.extendedSearchLoaded, query = searchData.query, peoplePage = searchData.peoplePage, extendedSearchLoading = searchData.extendedSearchLoading, companiesPage = searchData.companiesPage, buyerPage = searchData.buyerPage, searchLoaded = searchData.searchLoaded, documentPage = searchData.documentPage, documentSection = searchData.documentSection;
    var startTime = getCurrentTime();
    var peopleCount = peopleSection.count;
    var companiesCount = companiesSection.count;
    var buyerCount = buyerSection.count;
    var documentCount = documentSection.count;
    var disclessPersonality = gilroyStates.disclessPersonality;
    var isGilRoyV3 = disclessPersonality ? (!window.location.pathname.includes('feed') && !window.location.pathname.includes('person'))
        : !window.location.pathname.includes('feed');
    var fetchMore = function (type) {
        if (type === 'person') {
            dispatch(actions.globalSearchResults({
                query: query.includes(type) ? query : "".concat(type, ":").concat(query),
                screenName: 'Gilroy',
                page: peoplePage + 1,
                defaultLanguage: getLangCookie(),
            }));
        }
        else if (type === 'company') {
            dispatch(actions.globalSearchResults({
                query: query.includes(type) ? query : "".concat(type, ":").concat(query),
                screenName: 'Gilroy',
                page: companiesPage + 1,
                defaultLanguage: getLangCookie(),
            }));
        }
        else if (type === 'group') {
            dispatch(actions.globalSearchResults({
                query: query.includes(type) ? query : "".concat(type, ":").concat(query),
                screenName: 'Gilroy',
                page: buyerPage + 1,
                defaultLanguage: getLangCookie(),
            }));
        }
        else if (type === 'document') {
            dispatch(actions.globalSearchResults({
                query: query.includes(type) ? query : "".concat(type, ":").concat(query),
                screenName: 'Gilroy',
                page: documentPage + 1,
                defaultLanguage: getLangCookie(),
            }));
        }
    };
    var onClick = function (item) {
        onCrossClick();
        var isIdExists = uniqueTagList === null || uniqueTagList === void 0 ? void 0 : uniqueTagList.some(function (tag) { return item.id === tag.id; });
        if (uniqueTagList.length < TAG_LIMIT || isIdExists) {
            dispatch(actions.setTaggedItem(item));
            dispatch(actions.setUniqueTaggedItem(item));
            if (item.personType === 'LIVESEARCH') {
                dispatch(actions.tagLiveSearchPerson({
                    personId: item.id,
                    type: item.personType,
                    screenName: 'gilroy',
                }));
            }
            else if (item.type === 'company') {
                dispatch(actions.companySetup({ companyId: item.id }));
            }
            else if (item.type === 'group') {
                dispatch(actions.groupSetup({ groupId: item.id }));
            }
            else if (item.type === 'person') {
                dispatch(actions.personSetup({ personId: item.id }));
            }
            var type = item.type, id = item.id;
            if (type === 'document') {
                dispatch(flurryActions.callFlurryEvent(valueToObject('xcgpt_document_selected_searchPopup', 0, { document_id: id, host: host })));
            }
            else if (type === 'company') {
                dispatch(flurryActions.callFlurryEvent(valueToObject('xcgpt_company_selected_searchPopup', 0, { company_id: id, host: host })));
            }
            else if (type === 'person') {
                dispatch(flurryActions.callFlurryEvent(valueToObject('xcgpt_person_selected_searchPopup', 0, { person_id: id, host: host })));
            }
            else if (type === 'group') {
                dispatch(flurryActions.callFlurryEvent(valueToObject('xcgpt_buyerGroup_selected_searchPopup', 0, { group_id: id, host: host })));
            }
        }
        else {
            dispatch(flurryActions.callFlurryEvent(valueToObject('xcgpt_tagLimitReached', startTime, {
                host: host,
            })));
            dispatch(actions.setLimitPopupVisible(true));
        }
    };
    useEffect(function () {
        if (searchLoaded && popoverOpen) {
            setActive(activeTab);
        }
    }, [searchLoaded]);
    var paginationLoading = (searchLoaded || extendedSearchLoaded)
        && (searchLoading);
    return (_jsxs(ContentWrapper, __assign({ className: classNames({
            ContentV3: isGilRoyV3,
            loaderWrapper: searchLoading && !searchLoaded,
        }), onClick: function (e) { e.stopPropagation(); } }, { children: [(searchLoading && !searchLoaded)
                ? (_jsx("img", { src: loadingGifGlobalSearch, alt: "loader", className: "gif-loader" })) : null, (searchLoaded) ? (_jsx(PopoverTabs, { active: active, setActive: setActive, peopleCount: peopleCount, companiesCount: companiesCount, buyerCount: buyerCount, onCrossClick: onCrossClick, docCount: documentCount })) : null, popoverOpen && searchLoaded
                && ((active === 1 && extendedSearchLoaded && !peopleCount)
                    || (active === 2 && !companiesCount) || (active === 3 && !buyerCount)
                    || (active === 4 && !documentCount))
                ? _jsx(NoPersonsFound, { title: "No Results Found" })
                : null, (searchLoaded) ? (_jsxs(_Fragment, { children: [_jsx(PeopleResultTagging, { people: __spreadArray(__spreadArray([], (_b = peopleSection === null || peopleSection === void 0 ? void 0 : peopleSection.persons) !== null && _b !== void 0 ? _b : [], true), (_c = peopleSection.liveSearchPersons) !== null && _c !== void 0 ? _c : [], true), fetchMore: fetchMore, handleClick: onClick, active: active, pagination: paginationLoading, extendedLoading: searchLoaded && extendedSearchLoading && !extendedSearchLoaded }), _jsx(CompanyResultTagging, { companies: (_d = companiesSection === null || companiesSection === void 0 ? void 0 : companiesSection.companies) !== null && _d !== void 0 ? _d : [], fetchMore: fetchMore, handleClick: onClick, active: active, loading: paginationLoading && !!((_e = companiesSection.companies) === null || _e === void 0 ? void 0 : _e.length) }), _jsx(BRMResultTagging, { buyers: (_f = buyerSection.groups) !== null && _f !== void 0 ? _f : [], fetchMore: fetchMore, handleClick: onClick, active: active, loading: paginationLoading && !!((_g = buyerSection.groups) === null || _g === void 0 ? void 0 : _g.length) }), _jsx(DocResultTagging, { documents: (_h = documentSection.documents) !== null && _h !== void 0 ? _h : [], fetchMore: fetchMore, handleClick: onClick, active: active, isGilRoyV3: isGilRoyV3 })] })) : null] })));
};
var SearchTaggingPopover = function SearchTaggingPopover(props) {
    var activeTab = props.activeTab, children = props.children, openPopover = props.openPopover, onCrossClick = props.onCrossClick;
    var isGilRoyV3 = !window.location.pathname.includes('feed');
    return (_jsx(Popover, __assign({ open: openPopover, placement: "top", content: (_jsx(PopoverContent, { activeTab: activeTab, onCrossClick: onCrossClick, popoverOpen: openPopover })), overlayClassName: classNames('popover-tagging-gilroy', { gilroyV3TaggingPopover: isGilRoyV3 }), getPopupContainer: function () { return document.querySelector('.custom-text-area-gilroy'); }, autoAdjustOverflow: false }, { children: children })));
};
export default SearchTaggingPopover;
var templateObject_1;
